<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="mutationLoading">
    <template v-slot:activator="{ on }">
      <v-btn v-bind="$attrs" v-on="on" color="success">Upload files</v-btn>
    </template>

    <v-card :loading="mutationLoading">
      <v-card-title>
        <span class="title">Upload files - {{ uploadPath }}</span>
      </v-card-title>

      <v-card-text>
        <v-form v-model="valid">
          <v-row no-gutters>
            <v-col>
              <v-data-table
                no-data-text="No files selected"
                :headers="headers"
                hide-default-footer
                :hide-default-header="!files[0]"
                :items="filesToUpload"
              >
                <template v-slot:item.size="{ item }">{{ item.size | prettyBytes }}</template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" text @click="$refs.fileInput.click()">
          Select files
          <input
            type="file"
            style="display:none"
            accept="audio/*, video/*, image/*, .pdf"
            ref="fileInput"
            multiple
            @change="selectFileToUpload"
          />
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          :disabled="!files[0]"
          color="success"
          @click="upload"
          text
          :loading="mutationLoading"
        >Upload</v-btn>

        <v-btn color="error" @click="close" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { uploadMediaFiles } from '@/graphql/media.gql'
import swal from 'sweetalert2'

export default {
  name: 'UploadFiles',
  inheritAttrs: true,
  props: {
    uploadPath: {
      type: String,
      default: '/uploads/'
    }
  },
  data: () => ({
    valid: false,
    headers: [
      {
        text: 'File name',
        sortable: false,
        value: 'name'
      },
      {
        text: 'Type',
        sortable: false,
        value: 'type'
      },
      {
        text: 'File size',
        sortable: false,
        align: 'right',
        value: 'size',
        width: '120px'
      }
    ],
    mutationLoading: false,
    dialog: false,
    files: []
  }),
  computed: {
    filesToUpload() {
      let filesArray = Array.from(this.files)

      return filesArray.map(file => {
        return {
          name: file.name,
          type: file.type,
          size: file.size
        }
      })
    }
  },
  watch: {
    dialog() {
      this.files = []
    }
  },
  methods: {
    selectFileToUpload(event) {
      this.files = event.target.files
    },
    upload() {
      this.mutationLoading = true

      this.$apollo
        .mutate({
          mutation: uploadMediaFiles,
          variables: {
            data: {
              path: this.uploadPath,
              files: this.files
            }
          }
        })
        .then(data => {
          let responses = data.data.uploadMediaFiles
          let message = ''

          responses.forEach(upload => {
            message += `<h4>${upload.message}</h4>`
          })

          this.handleGraphQLSuccess(message, true, 3000, 'info')

          this.dialog = false

          this.$emit('uploaded')
          this.files = []

          this.mutationLoading = false
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          this.mutationLoading = false
        })
    },
    close() {
      this.dialog = false
      this.$emit('closed')
    }
  }
}
</script>
